import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Zap } from "lucide-react";

export const StickyCTA = ({ onClick }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consultEl = document.getElementById("consult");
    let consultVisible = false;

    const onScroll = () => {
      const pastHero = window.scrollY > window.innerHeight * 0.9;
      setVisible(pastHero && !consultVisible);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        consultVisible = entry.isIntersecting;
        onScroll();
      },
      { threshold: 0.15 }
    );
    if (consultEl) observer.observe(consultEl);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.2, 0.8, 0.2, 1] }}
          onClick={onClick}
          data-testid="sticky-cta-button"
          className="btn-lift glow-lime-strong fixed bottom-5 left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-8 z-50 flex items-center gap-2 rounded-full bg-[color:var(--hs-lime)] text-[color:var(--hs-bg-0)] font-semibold px-6 h-13 py-3.5 text-sm sm:text-base"
        >
          <Zap className="h-4 w-4" />
          Book Free 20-Min Consult
        </motion.button>
      )}
    </AnimatePresence>
  );
};
